import React from "react";
import { useNavigate } from 'react-router-dom';
import { Dropdown, Tooltip } from 'antd';
import { EllipsisOutlined } from '@ant-design/icons';
import { supplierUseMutation } from '../hooks';
import SupplierConst from '../supplier-const';
import { EntityRemoveButton, Localize } from 'components/service';
import { localizeByKey, localizeByKeyStatic } from "components/service/localize";
import Icons from 'components/icons';
import { usePermissionByObject } from "components/permissions";

interface ISupplierActionFieldProps
{
    supplierId: string;
    supplierName: string;
}

const SupplierActionField: React.FC<ISupplierActionFieldProps> = ({ supplierId, supplierName }) =>
{
    const navigate = useNavigate();

    const {
        _setMutationSupplierDelete,
        loadingMutationSupplierDelete,
    } = supplierUseMutation.delete(supplierId);

    const { hasPermission: hasUpdatePermission } = usePermissionByObject(SupplierConst.permissions.UPDATE);
    const { hasPermission: hasDeletePermission } = usePermissionByObject(SupplierConst.permissions.DELETE);

    const items = [
        {
            label: (
                <Tooltip
                    title={!hasUpdatePermission ? `${localizeByKeyStatic('PERMISSION.Error_AccessDenied')}: ${localizeByKeyStatic(SupplierConst.permissions.UPDATE.slug)}` : undefined}
                >
                    <span style={{ display: "flex", alignItems: "center", width: "100%" }}>
                        <Icons.Edit />
                        <Localize>MENUS_DROP.Label_Edit</Localize>
                    </span>
                </Tooltip>
            ),
            key: '1',
            disabled: !hasUpdatePermission,
            onClick: hasUpdatePermission ? () => navigate(`${SupplierConst.basePath}/${supplierId}`) : undefined,
        },
        {
            key: '2',
            disabled: !hasDeletePermission,
            label: (
                <EntityRemoveButton
                    modalButton={
                        <Tooltip
                            title={!hasDeletePermission ? `${localizeByKeyStatic('PERMISSION.Error_AccessDenied')}: ${localizeByKeyStatic(SupplierConst.permissions.DELETE.slug)}` : undefined}
                        >
                            <span style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                                <Icons.Delete />
                                <Localize>MENUS_DROP.Label_Delete</Localize>
                            </span>
                        </Tooltip>
                    }
                    nameEntity={localizeByKey("ENTITY.Modal_Title_Supplier")}
                    dataNameEntity={supplierName}
                    loading={loadingMutationSupplierDelete}
                    deleteMutation={(options) => {
                        if (!hasDeletePermission) {
                            return Promise.reject(new Error('Access denied'));
                        }
                        return _setMutationSupplierDelete(options);
                    }}
                    variables={{
                        id: supplierId,
                    }}
                    disabled={!hasDeletePermission}
                />
            ),
        },
    ];

    return (
        <Dropdown
            placement="bottomRight"
            menu={{ items }}
            overlayClassName="drop-more-menu"
            arrow
        >
            <EllipsisOutlined className="btn-more" />
        </Dropdown>
    );
};

export default SupplierActionField;

